module.exports = __webpack_public_path__ + "static/your-customer@2x-dc82c9ebacb8d6e1960b00721c15d863.png";